import store from "@/store";
import InitPage from "@/views/initPage.vue";
import LoginPage from "@/views/LoginPage.vue";
import MainDashboard from "@/views/MainDashboard.vue";
// import M_Dashboad from "@/views/mobile/M_Dashboad.vue";
import { createRouter, createWebHistory } from "vue-router";

// // mobile / pc 확인
// const isMoble = () => {
//   const info = navigator.userAgent;
//   let flag = false;
//   if (
//     info.indexOf("iPhone") > -1 ||
//     info.indexOf("Android") > -1 ||
//     info.indexOf("iPad") > -1 ||
//     info.indexOf("iPod") > -1
//   ) {
//     flag = true;
//   }
//   return flag;
// };

// pc 페이지 라우팅
const routes = [
  {
    path: "/",
    name: "MainDashBoard",
    meta: {
      requiredAuth: true,
    },
    component: MainDashboard,
  },
  {
    path: "/init",
    name: "InitPage",
    meta: {
      requiredAuth: true,
    },
    component: InitPage,
  },
  {
    path: "/auth/login",
    name: "login",
    meta: {
      requiredAuth: false,
    },
    component: LoginPage,
  },
];
// // mobile 페이지 라우팅
// const mobileRoutes = [
//   {
//     path: "/",
//     name: "M_Dashboard",
//     meta: {
//       requiredAuth: true,
//     },
//     component: M_Dashboad,
//   },
//   {
//     path: "/init",
//     name: "InitPage",
//     meta: {
//       requiredAuth: true,
//     },
//     component: InitPage,
//   },
//   {
//     path: "/auth/login",
//     name: "login",
//     meta: {
//       requiredAuth: false,
//     },
//     component: LoginPage,
//   },
// ];

// vue 전역 라우팅 생성
const router = createRouter({
  history: createWebHistory(),
  // routes: isMoble() ? mobileRoutes : routes,
  routes: routes,
});

// 각 라우터 (페이지) 요청에 대한 인가,인증 확인 로직
router.beforeEach(async (to, from, next) => {
  if (to.meta.requiredAuth) {
    /*
    로그인 되어있는지 확인
    - 로그인시 access token 을 "userStore" 와 "localStorage" 에 각각 저장.
    새로고침시 store 는 초기화 되기 때문에 (휘발성) localStorage 에 토큰 값이 있는지 확인 해야함
    */
    const isLogin = async () => {
      return (
        (await localStorage.getItem("user")) &&
        localStorage.getItem("user") != "null"
      );
    };

    if (!(await isLogin())) {
      /*
       FIXME :  로그인이 되어있지 않다면, 로그인 페이지로 이동
       */
      return next({
        path: "/auth/login",
        state: { redirect: to.fullPath },
      });
    } else {
      /*
      FIXME : 로그인이 되어 있다면, 사용자 토큰 확인 및 기본 설정 확인 
      */

      // 유저 엑세스 토큰 확인
      await store.dispatch(`userStore/AC_CHECK_ACCESS_TOKEN`);
      // init status 할당
      await store.dispatch(`userStore/AC_USER_INIT_CHECK`);
      // 본 서비스를 이용하기 위한 기본 설정이 완료 되었는지 확인
      const isComplete = store.getters["userStore/IS_INIT_COMPLETE"];

      if (to.path === "/init") {
        return next();
      } else {
        if (!isComplete) {
          return next({ path: "/init" });
        } else {
          return next();
        }
      }
    }
  } else {
    // 그 외의 경우 요청 페이지로 이동
    next();
  }
});

export default router;
